import React from 'react';

import { Button } from '@/design-system/atoms/Button';
import { ContentContainer } from '@/design-system/atoms/ContentContainer';
import { Grid, GridColumn } from '@/design-system/atoms/Grid';
import { Text } from '@/design-system/atoms/Text';
import { Title } from '@/design-system/atoms/Title';
import { ProviderCarouselCard } from '@/design-system/molecules/ProviderCarouselCard';

import styles from '../../ProviderCarousel.module.scss';

const DesktopProviderCarousel = (props) => {
    const { title, ctaPreText, cta, providers, showCta } = props;
    return (
        <ContentContainer className={styles[`provider-carousel__desktop`]}>
            {title && (
                <Title
                    tag={Title.TAG.H2}
                    variant={Title.VARIANT.H3}
                    content={title}
                    className={styles[`provider-carousel__title`]}
                />
            )}
            <Grid col={{ sm: 4, md: 6, lg: 12 }}>
                {providers.map((provider, index) => (
                    <GridColumn key={index} colSpan={{ sm: 4, md: 6, lg: 3 }}>
                        <ProviderCarouselCard
                            {...provider}
                            analytics={{ componentTitle: title, componentName: 'Doctor Carousel' }}
                        />
                    </GridColumn>
                ))}
                {showCta && (
                    <GridColumn colSpan={{ sm: 4, md: 6, lg: 3 }}>
                        <div className={styles[`provider-carousel__cta-card`]}>
                            <Text
                                variant={Text.VARIANT.H5}
                                tag={Text.TAG.P}
                                content={ctaPreText || 'Want to see more specialists?'}
                                className={styles[`provider-carousel__cta-pretext`]}
                            />
                            <div className={styles[`provider-carousel__cta-container`]}>
                                <Button
                                    {...cta}
                                    buttonStyle={Button.STYLE.PRIMARY}
                                    analytics={{
                                        componentName: 'Doctor Carousel',
                                        componentTitle: title,
                                    }}
                                />
                            </div>
                        </div>
                    </GridColumn>
                )}
            </Grid>
        </ContentContainer>
    );
};

export default DesktopProviderCarousel;
